import { render, staticRenderFns } from "./Contact-card.vue?vue&type=template&id=55dea5dd&scoped=true&"
import script from "./Contact-card.vue?vue&type=script&lang=js&"
export * from "./Contact-card.vue?vue&type=script&lang=js&"
import style0 from "./Contact-card.vue?vue&type=style&index=0&id=55dea5dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dea5dd",
  null
  
)

export default component.exports